<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-page-header @back="goBack" content="订单退款/退货详情"></el-page-header>
    </el-breadcrumb>
    <el-card class="box-card" style="margin-top:20px">
      <div class="step_box">
        <el-steps :active="2">
          <el-step title="下单日期" :description="info.order_time!=null?dateFormat(info.order_time):''"></el-step>
          <el-step title="付款" :description="info.pay_time!=null?dateFormat(info.pay_time):''"></el-step>
          <el-step title="发货" description=""></el-step>
          <el-step title="收货" description=""></el-step>
          <el-step title="完成" description=""></el-step>
        </el-steps>
      </div>
      <el-descriptions title="订单详情" :column="3" border size="small">
        <el-descriptions-item label="订单编号：">{{info.order_sn}}</el-descriptions-item>
        <el-descriptions-item label="会员">{{info.user.user_name}}</el-descriptions-item>
        <el-descriptions-item label="订单金额：">{{info.order_amount}}</el-descriptions-item>
        <el-descriptions-item label="收货人：" >{{info.consignee}}</el-descriptions-item>
        <el-descriptions-item label="收货电话：">{{info.tel}}</el-descriptions-item>
        <el-descriptions-item label="收货地址：">{{info.address}}</el-descriptions-item>
      </el-descriptions>
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <el-table
        style="margin-top: 20px;"
        ref="multipleTable"
        :data="goodsList"
        size="mini"
        stripe
        border
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          label="产品名称"
          width="200"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="规格"
          width="200"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.sku_china}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="数量"
          width="50"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.goods_number}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="金额"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.formated_shop_price}}</span>
          </template>
        </el-table-column>

      </el-table>


      <el-form
        :inline="true"
        :model="addForm"
        :rules="rules"
        ref="formForRef"
        label-width="80px"
        autocomplete="on"
        size="small"
      >
        <el-descriptions title="发货信息" :column="2" border size="small">
          <el-descriptions-item label="运单号：" >
            <el-form-item prop="invoice_no">
              <el-input
                type="textarea"

                placeholder="请输入运单号"
                v-model="addForm.invoice_no">
              </el-input>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item label="发货日期：">
            <el-date-picker value-format="yyyy-MM-DD HH:mm:ss" clearable type="datetime" placeholder="选择发货日期" v-model="addForm.shipping_time" style="width: 100%;"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="快递公司：">
            <el-input style="display:flex;align-items: center;" width="400" placeholder="请选择快递公司" @click.native="chooseS" v-model="addForm.shipping_name" type="text" >
              <span slot="suffix" style="color: #ff0000;">...</span>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="备注：">
            <el-form-item prop="remark">
              <el-input
                type="textarea"

                placeholder="请输入备注"
                v-model="addForm.remark">
              </el-input>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item :column="2">

            <el-button  size="mini" type="primary" @click="submitForm">确定</el-button>
          </el-descriptions-item>
        </el-descriptions>
      </el-form>

      <div class="block" style="margin-top: 10px;">
        <el-timeline>
          <el-timeline-item v-for="(item,id) in shipping_order_list" :key="id" :timestamp="dateFormat(item.shipping_time)" placement="top">
            <el-card>
             <div style="display: flex;flex-direction: row;justify-content: space-between;">
               <p><label style="color: #999">运单号:</label><span>{{item.invoice_no}}</span></p>
               <p><label style="color: #999">快递公司:</label><span>{{item.shipping?item.shipping.shipping_name:''}}</span></p>
               <p><label style="color: #999">备注:</label><span>{{item.remark}}</span></p>
             </div>
            </el-card>
          </el-timeline-item>

        </el-timeline>
      </div>
    </el-card>
    <eShopping  :formData="formData"
                :visible.sync="visible"
                :title="title"
                :closeForm="closeForm"
    />
  </div>
</template>
<script>
  import eShopping from "../common/eShoppingList.vue";
  import axios from 'axios'
  import moment from 'moment'     //日期时间转换
  export default {
    name: "orderRefundInfo",
    components: {eShopping },
    data() {

      return {
        formData:{},
        title:'',
        visible:false,

        checkAll: false,
        isIndeterminate: false,
        multipleSelection: [],
        goodsList:[],
        shipping_order_list:[],
        employeeList:[],

        baseUrl:'/api/',
        fileList:[],
        shopList:[],
        dicList:[],
        cateList:[],
        provinceList:[],
        info:{},
        addForm:{
          shipping_time:'',
          shipping_status:'',
          invoice_no:'',//运单号
          shipping_name:'',//快递公司名称，
          shipping_id:'',


          id:'',

          type_names:'',
          handed_other_name:'',
          handed_id:'',
          address:'',
          total_amount:'',
          payee_account:'',
          payee_name:'',
          credit_code:'',
          employee_id:'',
          type_id:'',
          cate_id:'',
          province_id:"",
          dic_id:'',
          amount:'',
          remark:'',
          order_time:'',
          summary:"",
          manager_name:'',
          unit_name:"",
          title:'',
          shop_id:sessionStorage.getItem('shop_id'),
          access_token:sessionStorage.getItem('token'),
          fileList:[],
          company_id:sessionStorage.getItem('company_id'),
        },
        ruleForm:{
          url:'',
          start_time:"",
          ad_id:'',
          ad_name:'',
          ad_link:'',
          position_id:'',
          ad_code:''
        },
        cateMenus:[],
        editor: null,
        html: '<p>hello</p>',
        toolbarConfig: { },
        editorConfig: { placeholder: '请输入内容...',
          // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            //配置上传图片
            uploadImage: {
              customUpload: this.uploadImg
            }
          }
        },
        mode: 'default', // or 'simple'
        rules: {
          title:[
            { required: true, message: "请输入合同名称", trigger: 'change' }
          ],
          position_id:[
            { required: true, message: "请选择分类", trigger: 'change' }
          ],

        },
      }
    },
    mounted() {
      var id= this.$route.query.id;
      if(!isNaN(id)&&id>0){
        this.addForm.id=id;
        this.getOne();
      }
    },
    methods: {
      closeForm(){
        this.addForm.shipping_name=this.formData.name;
        this.addForm.shipping_id=this.formData.id;
        this.visible=false;
      },
      chooseS(){
        this.title="选择快递公司";
        this.visible=true;
      },
      handleCheckAllChange(val) {
        this.$refs.multipleTable.clearSelection();
        if (val) {
          this.goodsList.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          });
        }
        this.isIndeterminate = false;
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.checkAll = this.multipleSelection.length === this.goodsList.length;
        this.isIndeterminate = this.multipleSelection.length > 0 && !this.checkAll;
      },

      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      getTypeList(){
        let _this=this;
        let param={
          access_token: _this.addForm.access_token,
          company_id: _this.addForm.company_id,
          ids:_this.info.type_ids
        };
        this.$axios.dicListByIds(param).then((res)=>{
          if(res.code==200){
            res.data.forEach(function(item){
              _this.addForm.type_names +=item.name+',';

            })
          }
          console.log(res);
        });
      },
      goBack() {
        this.$router.go(-1);
      },
      getfile(item){
        return item.url.split('/').pop();
      },

      getDicList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"InvoiceType",
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            this.dicList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getCateList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"InvoiceCate",
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            this.cateList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getEmployeeList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.employeeList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getProvinceList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          parent_id:1,
        }
        this.$axios.regionList(param).then(res=>{
          if(res.code == 200){
            this.provinceList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getShopList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),

        }
        this.$axios.shopList(param).then(res=>{
          if(res.code == 200){
            this.shopList =res.data;
            this.addForm.shop_id=res.data[0].id;
            this.DataList();
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },

      submitForm(){

        if(this.multipleSelection.length<1){
          this.$message.error("请选择要发货的产品");
           return;
        }
        console.log('this.multipleSelection',this.multipleSelection)

        this.$refs.formForRef.validate((valid) => {
          if (valid) {
            let params=this.addForm;
            params.order_id=params.id;
            let goods_list=[];
            this.multipleSelection.map(x=>{
              let tmp={
                 num:x.goods_number,
                 rec_id:x.rec_id
              };
              goods_list.push(tmp);
            })
            params.goods_list=JSON.stringify(goods_list);
            console.log('params------',params)

            this.$axios.shippingOrderInfoSave(params).then(res=>{
              if(res.code == 200){
                this.$message.success("保存成功");
                this.$router.push('/shippingOrderList')
              }
            }).catch(error=>{
              this.$message.error("保存错误");
              console.log(error);
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getOne(){
        let _this=this;
        let param={
          access_token: _this.addForm.access_token,
          company_id: _this.addForm.company_id,
          order_id:_this.addForm.id
        };
        this.$axios.shippingOrderInfo(param).then((res)=>{
          if(res.code==200){
            this.info=res.data;
            _this.goodsList=_this.info.goods_list;
            this.addForm.invoice_no= this.info.invoice_no;
            this.addForm.shipping_name= this.info.shipping_name;
            this.addForm.shipping_id= this.info.shipping_id;
            this.addForm.shipping_time= this.info.shipping_time?this.dateFormat( this.info.shipping_time):'';
            this.getShippingOrderList();
           // // _this.getTypeList();
           //  if(res.data.file_urls){
           //    var i=0;
           //    res.data.file_urls.split(',').forEach(function(el) {
           //      var img={
           //        name:res.data.title+i,
           //        url:el
           //      }
           //      console.log('file-----------',img)
           //      _this.addForm.fileList.push(img);
           //      i=i+1;
           //    });
           //
           //  }
          }
          console.log(res);
        });
      },
      getShippingOrderList(){
        let _this=this;
        let param={
          access_token: _this.addForm.access_token,
          company_id: _this.addForm.company_id,
          order_id:_this.addForm.id,
          shop_id:_this.addForm.shop_id
        };
        this.$axios.shippingOrderList(param).then((res)=>{
          if(res.code==200){
            this.shipping_order_list=res.data;
          }
          console.log(res);
        });
      },
      uploadFile (item) {
        let _this=this;
        let file = item.raw;
        this.logoFile=item.raw;
        // formData.append('file', file);
        let param={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id')
        };
        this.$axios.getAliJson(param).then(res=>{
          let data = res['data'];
          console.log('aliyun',data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let host = data['host'];
          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key + 'mrh/' + autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('aliyun5555',request);

          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;

            _this.ruleForm.ad_code=fullurl;
            var img={
              name:_this.ruleForm.ad_name,
              url:_this.ruleForm.fullurl
            }
            _this.fileList.push(img);
          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
        });

      },
      resetForm(formName){
        this.$refs[formName].resetFields();
      },
      handleBeforeUpload() {
        console.log('aaaaa');
      },
      uploadSuccess(){

      },
      handleIsopenSelect(){

      },

      getCateMenus(){
        let _this = this;
        let url= '/api/api/mall.Ad_read_lz/getAdPositionMenus';
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        axios.post(url,params).then((res)=>{
          if(res.data.code == 200) {
            _this.cateMenus=res.data.data;
          }
        });
        _this.submit=false;
      },
      uploadImg(file, insertFn){

        let _this=this;
        let param={
          access_token: sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        // console.log(file);
        this.$axios.getAliJson(param).then(res=>{
          console.log('ali_json------',res)

          let data=res['data'];
          console.log(data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let  host = data['host'];

          // let fParam=
          //  {
          //    name:file.name,
          //    key:key +'mrh/'+ autoname + suffix,
          //    policy:data['policy'],
          //    OSSAccessKeyId:data['accessid'],
          //    success_action_status:'200',
          //    callback:data['callback'],
          //    Signature:data['signature'],
          //    file:file
          //  };
          //
          //  qs.stringify(fParam)
          //{headers:{'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'}}

          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key +'mrh/'+ autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('file=------',file)
          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;
            setTimeout(function(){
              insertFn(fullurl); //插入地址
            },2000);


          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
          // $.ajax({
          //   url: host,
          //   data: request,
          //   processData: false,//默认true，设置为 false，不需要进行序列化处理
          //   cache: false,//设置为false将不会从浏览器缓存中加载请求信息
          //   async: false,//发送同步请求
          //   contentType: false,//避免服务器不能正常解析文件---------具体的可以查下这些参数的含义
          //   // dataType: 'json',//不涉及跨域  写json即可
          //   type: 'post',
          //   success: function (callbackHost, request) { //callbackHost：success,request中就是 回调的一些信息，包括状态码什么的
          //     console.log(callbackHost);
          //     var fileurl = callbackHost.filename; //上传完成后的文件oss地址
          //     var fullurl=host+'/'+fileurl;
          //     var fileObj={
          //       'file_url':fullurl,
          //       'file_path':fileurl
          //     };
          //     console.log(fileObj);
          //     let tempList=vm.picList;
          //     console.log(tempList);
          //     tempList.push(fileObj);
          //    // vm.picList=tempList;
          //
          //     // $('#m-f-up').append("<li><a href='../images/demopic4.jpg'><img src='../images/demopic4.jpg' /></a><i  class='iconfont icon-weikaitong'></i></li>");
          //     //   $('#ad_code').val(fullurl);
          //     // $("#upload_img_icon img").attr('src',fullurl);
          //   },
          //   error: function(XMLHttpRequest, textStatus, errorThrown) {
          //     alert(XMLHttpRequest.status);
          //     alert(XMLHttpRequest.readyState);
          //     alert(textStatus);
          //   }
          // });
        });

        // let imgData = new FormData();
        // imgData.append('file', file);
        // console.log('lu-----------',file)
        // //调用上传图片接口，上传图片  我这里testUpImg是测试接口
        // testUpImg(imgData).then(response => {
        //   if(response.data.code == 0){
        //     //插入后端返回的url
        //     insertFn(response.data.data.url);
        //   }else{
        //   }
        // })
      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second;
      },
      urlParse(_url = '') {
        let url_obj = new URL(_url || window.location.href);
        let search_path = url_obj.search;
        let handle_path = decodeURIComponent(search_path.substr(1));

        let handle_path_arr = handle_path.split('&');
        let search_params = {};
        for(let item of handle_path_arr) {
          let r = item.split('=');
          search_params[r[0]] = r[1];
        }
        return {
          protpcol: url_obj.protocol,
          search: url_obj.search,
          host: url_obj.host,
          port: url_obj.port,
          pathname: url_obj.pathname,
          searchParams: search_params
        }
      },

    },

    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },

  };
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
